import {AppComponent} from './app.component';
import {LoginComponent} from './auth/login/login.component';
import {Routes} from '@angular/router';

import {FullComponent} from './layouts/full/full.component';
import {IsLoggedInGuard} from './guards/is-logged-in.guard';
import {PasswordRecoveryComponent} from './auth/password-recovery/password-recovery.component';
import {ResetPasswordComponent} from './auth/reset-password/reset-password.component';
import {CompanyListResolver} from './resolvers/company-list-resolver.service';

export const Approutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'login/:token',
    component: LoginComponent
  },
  {
    path: 'password-recovery',
    component: PasswordRecoveryComponent
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent
  },
  {
    path: '',
    component: AppComponent,
    runGuardsAndResolvers: 'always',
    children: [
      { path: '',
        component: FullComponent,
        resolve: { companyList: CompanyListResolver },
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: 'admin',
            loadChildren: './admin/admin.module#AdminModule',
            canLoad: [IsLoggedInGuard],
            runGuardsAndResolvers: 'always',
          }
        ]
      },
    ]
  }
];
